export var ChangeSetState;
(function (ChangeSetState) {
    ChangeSetState[ChangeSetState["New"] = 0] = "New";
    ChangeSetState[ChangeSetState["Sending"] = 1] = "Sending";
    ChangeSetState[ChangeSetState["Failed"] = 2] = "Failed";
    ChangeSetState[ChangeSetState["Sended"] = 3] = "Sended";
    ChangeSetState[ChangeSetState["Offline"] = 4] = "Offline";
})(ChangeSetState || (ChangeSetState = {}));
export var ChangeSetSource;
(function (ChangeSetSource) {
    ChangeSetSource[ChangeSetSource["Unknown"] = 0] = "Unknown";
    ChangeSetSource[ChangeSetSource["Operation"] = 1] = "Operation";
    ChangeSetSource[ChangeSetSource["UndoRedo"] = 2] = "UndoRedo";
    ChangeSetSource[ChangeSetSource["Customize"] = 3] = "Customize";
})(ChangeSetSource || (ChangeSetSource = {}));
export var ChangeSetProcess;
(function (ChangeSetProcess) {
    ChangeSetProcess[ChangeSetProcess["Unknown"] = 0] = "Unknown";
    ChangeSetProcess[ChangeSetProcess["SendFailed"] = 1] = "SendFailed";
    ChangeSetProcess[ChangeSetProcess["Conflict"] = 2] = "Conflict";
    ChangeSetProcess[ChangeSetProcess["Offline"] = 3] = "Offline";
})(ChangeSetProcess || (ChangeSetProcess = {}));
export var ChangeSetTerminal;
(function (ChangeSetTerminal) {
    ChangeSetTerminal[ChangeSetTerminal["Unknown"] = 0] = "Unknown";
    ChangeSetTerminal[ChangeSetTerminal["ServerAccept"] = 1] = "ServerAccept";
    ChangeSetTerminal[ChangeSetTerminal["ServerRefuse"] = 2] = "ServerRefuse";
    ChangeSetTerminal[ChangeSetTerminal["ConflictRemove"] = 3] = "ConflictRemove";
    ChangeSetTerminal[ChangeSetTerminal["OfflineDuplicate"] = 4] = "OfflineDuplicate";
    ChangeSetTerminal[ChangeSetTerminal["Exception"] = 5] = "Exception";
    ChangeSetTerminal[ChangeSetTerminal["NetworkError"] = 6] = "NetworkError";
})(ChangeSetTerminal || (ChangeSetTerminal = {}));
export var ChangeSetApplyFailed;
(function (ChangeSetApplyFailed) {
    ChangeSetApplyFailed[ChangeSetApplyFailed["Unknown"] = 0] = "Unknown";
    ChangeSetApplyFailed[ChangeSetApplyFailed["ApplyNewChanges"] = 1] = "ApplyNewChanges";
    ChangeSetApplyFailed[ChangeSetApplyFailed["ConflictUndo"] = 2] = "ConflictUndo";
    ChangeSetApplyFailed[ChangeSetApplyFailed["ConflictApplyRemote"] = 3] = "ConflictApplyRemote";
    ChangeSetApplyFailed[ChangeSetApplyFailed["ConflictIndex"] = 4] = "ConflictIndex";
    ChangeSetApplyFailed[ChangeSetApplyFailed["ConflictRevert"] = 5] = "ConflictRevert";
    ChangeSetApplyFailed[ChangeSetApplyFailed["ConflictRedo"] = 6] = "ConflictRedo";
    ChangeSetApplyFailed[ChangeSetApplyFailed["Offline"] = 7] = "Offline";
    ChangeSetApplyFailed[ChangeSetApplyFailed["LocalOperation"] = 8] = "LocalOperation";
})(ChangeSetApplyFailed || (ChangeSetApplyFailed = {}));
export var CommitErrorCause;
(function (CommitErrorCause) {
    CommitErrorCause[CommitErrorCause["Default"] = 0] = "Default";
    CommitErrorCause[CommitErrorCause["ServerRefuse"] = 1] = "ServerRefuse";
})(CommitErrorCause || (CommitErrorCause = {}));
export var OperationType;
(function (OperationType) {
    OperationType["ADD"] = "add";
    OperationType["REMOVE"] = "remove";
    OperationType["REPLACE"] = "replace";
    OperationType["MOVE"] = "move";
})(OperationType || (OperationType = {}));
export var UnofficialOperationType;
(function (UnofficialOperationType) {
    UnofficialOperationType["GET"] = "_get";
})(UnofficialOperationType || (UnofficialOperationType = {}));
export var RuleType;
(function (RuleType) {
    RuleType["MERGE"] = "merge";
})(RuleType || (RuleType = {}));
//# sourceMappingURL=changeset-constants.js.map